/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_SubmitInputs */

const en_admin_create_submit = /** @type {(inputs: Admin_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Admin Account`)
};

const de_admin_create_submit = /** @type {(inputs: Admin_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Account erstellen`)
};

/**
* | output |
* | --- |
* | "Create Admin Account" |
*
* @param {Admin_Create_SubmitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_submit = /** @type {((inputs?: Admin_Create_SubmitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_SubmitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_submit(inputs)
	return en_admin_create_submit(inputs)
});